import Button from '@anm/components/buttons/Button';
import { flexCenter } from '@anm/styles/helpers';
import { FC } from 'react';
import styled from 'styled-components';

import withVideoFolder, {
  WithVideoFolder
} from '../../../../HOCs/withVideoFolder';
import routes from '../../../../routes';

const { Link } = routes;

const Wrapper = styled.div`
  ${flexCenter};
  text-align: center;
  flex-direction: column;
  min-height: 400px;
`;

const Text = styled.p`
  font-weight: 700;
  font-size: 24px;
  color: #919eaa;
  margin: 0;
`;

const StyledButton = styled(Button)`
  margin-top: 18px;
  font-size: 24px;
`;

type HOCs = WithVideoFolder;
type NotFoundFolderProps = {};

const NotFoundFolder: FC<HOCs & NotFoundFolderProps> = () => (
  <Wrapper>
    <Text>The folder could not be found.</Text>
    <br />
    <Text>
      Please make sure that the folder has not been
      <br /> renamed, moved, or deleted.
    </Text>
    <br />
    <Link route="my-projects">
      <a>
        <StyledButton variant="link" size="link-medium">
          Open My Projects
        </StyledButton>
      </a>
    </Link>
  </Wrapper>
);

export default withVideoFolder(NotFoundFolder);
